import React from "react";

// El formato impreso tiene un solo espacio de observaciones al pie, pero cada
// cierre captura las suyas. Se muestran juntas e identificadas, igual que en el
// Excel, para que el pie del reporte se lea como uno solo
export const ObservacionesDelPeriodo = ({ cierres }) => {
    const conTexto = cierres.filter((cierre) => !!cierre.observaciones);

    if (!conTexto.length) {
        return null;
    }

    return (
        <div className="reporte-inventario__resumen my-4">
            <label className="pl-0">Observaciones</label>

            {conTexto.map((cierre) => (
                <div key={cierre.id} className="mb-1">
                    <strong>{cierre.tipo_display}: </strong>
                    {cierre.observaciones}
                </div>
            ))}
        </div>
    );
};
